"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _messaging = require("../../../constants/messaging.types");

var _providers = require("../../../../../providers");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    boxImage: {
      height: '100%',
      border: 'none',
      '& > img': {
        borderRadius: 5
      }
    }
  };
});

var VidyardField = function VidyardField(_ref) {
  var control = _ref.control,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = useStyles();

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex.campaignId,
      vidyardClientId = _useGiftingFlowContex.vidyardClientId;

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: "".concat(_messaging.MessagingDataFields.VideoData, ".").concat(_messaging.VideoDataFields.Vidyard)
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var handleVidyardSelect = (0, _react.useCallback)(function (vidyard) {
    onChange({
      vidyardImage: "https:".concat(vidyard.thumbnail),
      vidyardVideo: "https:".concat(vidyard.base_url)
    });
  }, [onChange]);
  var handleRemoveVidyardVideo = (0, _react.useCallback)(function () {
    onChange(null);
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.VidyardIntegration, {
    levelName: _ui.VidyardLevelNames.CampaignSettings,
    levelObjectId: campaignId,
    image: (value === null || value === void 0 ? void 0 : value.imageUrl) || '',
    link: (value === null || value === void 0 ? void 0 : value.videoUrl) || '',
    handleSelect: handleVidyardSelect,
    onRemove: handleRemoveVidyardVideo,
    vidyardClientId: vidyardClientId,
    overrideClasses: {
      boxImage: classes.boxImage
    },
    disabled: disabled
  }), !!(error !== null && error !== void 0 && error.message) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 4
  }, /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true
  }, error === null || error === void 0 ? void 0 : error.message)));
};

var _default = VidyardField;
exports.default = _default;